// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__OU5O2","actionsCol":"EnrolledClinics_actionsCol__1l5uW"};